"use client";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import ApiService from "@/Services/ApiService";
import Icons from "../../../public/icons/othersIcon";

const JoinOurTeam = () => {

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log({ name: name, value: value });
    if (name === "email") {
      setEmail(value);
    }
  };

  const validation = () => {
    let errors = {};
    let formIsValid = true;
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!email || regex.test(email) === false) {
      formIsValid = false;
      errors["Email"] = "*Please enter your valid EmailID.";
    }

    setError(errors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (validation()) {
      console.log("error", error);
      const data = {
        email: email,
      };

      ApiService.post("api/newsletters", { data })
        .then(() => {
          setEmail("");
          toast.success("Thanks for reaching out. We'll get back to you soon!");
        })
        .catch((error) => {
          console.log(error);
          toast.error("Something is wrong!");
        });

      const response = await fetch("/api/sendMail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    }
  };
  return (
    <div className="px-10 py-24 container-padding-x" style={{ background: "linear-gradient(97.23deg, #E5F2FD -14.62%, #FFFFFF 110.74%)" }}>
      <h3 className="text_black text-center text-4xl m-0 p-0">
        <span className="g-b md:border-b-3 border-b-[#168DEF]">Subscribe To</span><span className="g-b text_blue md:border-b-3 border-b-[#168DEF]"> Our Newsletter </span>
      </h3>
      {/* <span className="bg-[#168DEF] h-[2px] w-[40%] block mx-auto"></span> */}
      <p className="g-m text-[16px] text_black text-center pt-3">
        Subscribe to Our Newsletter for the Latest features, Expert Analysis and Amazing Offers!
      </p>
      <div className="flex xl:flex-row flex-col justify-between mt-[24px]">
        <div className="w-[100%] xl:mx-[15%]">
          <TextField
            placeholder="Your E-mail here...."
            // variant="outlined"
            name="email"
            value={email}
            // className="g-m-placeholder"
            style={{
              width: '100%',
              borderRadius: "10px",
              background: "#fff",
              boxShadow: "0px 30px 116px -16px rgba(211, 211, 211, 0.20)",
            }}
            onChange={handleChange}
            InputProps={{
              inputProps: {
                className: "g-m-placeholder",
              },
              sx: {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(58, 61, 70, 0.2)",
                  borderWidth: "1px",
                },
                borderRadius: "10px",
              },
              endAdornment: (
                <InputAdornment position="end" className="subscribe_button">
                  <Button
                    // variant="contained"
                    // className="g-sm rounded-lg hover:!text-[#fff] hover:!bg-[#168DEF] "
                    style={{
                      border: '1px solid #168DEF !important', // Override border with important
                    //   borderRadius: '50px',  // Ensures rounded-full style is applied
                    //   color: '#168DEF',      // Text color
                    }}
                    className="border !border-[#168DEF] text-[#168DEF] rounded-[50px] g-sm px-[15px] custom-button min-[481px]:block hidden hover:bg-[#168DEF] hover:!text-[#fff]"
                    onClick={handleSubmit}
                  >
                    Subscribe
                    {/* <Icons name="right-arrow-icon" /> */}
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          <div className="text-[12px] text-red-500 max-[481px]:block hidden">
            {error.Email}
          </div>
          <span className="max-[481px]:block hidden">
            <button
              type="button"
              className=" text-white rounded-[10px] bg-[#168DEF]  py-[12px] px-4 border-2  text-[15px] my-6 xl:mt-0 xl:w-60 lg:w-[200px] md:w-60 sm:w-30 flex justify-center items-center"
              onClick={handleSubmit}
            >
              Subscribe &nbsp;&nbsp;
              <Icons name="right-arrow-icon" fill='#fff' />
            </button>
          </span>
        </div>
      </div>
      <div className="text-[12px] text-red-500 max-[426px]:hidden">
        {error.Email}
      </div>
    </div>
  );
};

export default JoinOurTeam;
